import Aspects from './Aspects';

export default Aspects;
